import { FieldDescription, getProperties, getFieldDescriptor } from "./field-descriptor"
import { isNullOrUndefined } from "util"

export abstract class DatatableEntity {
  id?: number
  static getFieldDescriptionList(): FieldDescription[] {
    const fieldDescriptionList: FieldDescription[] = []
    const prototype = this.prototype

    getProperties(prototype).forEach((property: string) => {
      const fieldDescriptor = getFieldDescriptor(prototype, property)
      if (!isNullOrUndefined(fieldDescriptor)) {
        fieldDescriptionList.push(fieldDescriptor)
      }
    })

    return fieldDescriptionList
  }
}
